import { fetch } from '../../utils';
import Backend from '../../backend';

export const getFinancialPyramidApi = async clientId => {
  return fetch(Backend.methodUrl(`financial-pyramids/${clientId}`))
    .then(response => response.json())
    .then(payload => payload)
    .catch(error => {
      throw error;
    });
};

export const updateFinancialPyramidApi = async (clientId, financialPyramid) => {
  return fetch(Backend.methodUrl(`financial-pyramids/${clientId}`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(financialPyramid)
  })
    .then(response => response.json())
    .then(payload => payload)
    .catch(error => {
      throw error;
    });
};
